import { render, staticRenderFns } from "./infoDetails.vue?vue&type=template&id=4fdca376&"
import script from "./infoDetails.vue?vue&type=script&lang=js&"
export * from "./infoDetails.vue?vue&type=script&lang=js&"
import style0 from "./infoDetails.vue?vue&type=style&index=0&id=4fdca376&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports